<router-outlet></router-outlet>

<app-landscape></app-landscape>